//Users
import Material from "../pages/inventory_management/material/index.js";
import AddMaterial from "../pages/inventory_management/material/add.js";
import EditMaterial from "../pages/inventory_management/material/edit.js";
import StockMovement from "../pages/inventory_management/stock_movement/index.js";
import UserStock from "../pages/inventory_management/user_stock/index.js";
import Reports from "../pages/inventory_management/reports/index.js";
//Composers
import MaterialComposer from "../composers/MaterialComposer.js";
import { DashboardComposer } from "../composers/DashboardComposer.js";
// Guards
import AuthGuard from "../components/guards/AuthGuard.js";
import DashboardLayout from "../layouts/Dashboard.js";
import ProtectedLayout from "../layouts/ProtectedLayout.js";

const MaterialRoutes = {
  path: "inventory-mgnt",
  element: (
    <AuthGuard>
      <DashboardComposer>
        <DashboardLayout />
      </DashboardComposer>
    </AuthGuard>
  ),
  roles: ["SUPER_ADMIN", "MULTI_SERVICE_OPERATOR", "LCO", "EMPLOYEE"],
  children: [
    {
      path: "material",
      children: [
        {
          path: "add",
          element: (
            <ProtectedLayout>
              <MaterialComposer>
                <AddMaterial />
              </MaterialComposer>
            </ProtectedLayout>
          ),
        },
        {
          path: "edit",
          element: (
            <ProtectedLayout>
              <MaterialComposer>
                <EditMaterial />
              </MaterialComposer>
            </ProtectedLayout>
          ),
        },
        {
          path: "list",
          element: (
            <ProtectedLayout>
              <MaterialComposer>
                <Material />
              </MaterialComposer>
            </ProtectedLayout>
          ),
        },
      ],
    },
    {
      path: "movement",
      children: [
        {
          path: "list",
          element: (
            <ProtectedLayout>
              <MaterialComposer>
                <StockMovement />
              </MaterialComposer>
            </ProtectedLayout>
          ),
        },
      ],
    },
    {
      path: "user-stock",
      children: [
        {
          path: "list",
          element: (
            <ProtectedLayout>
              <MaterialComposer>
                <UserStock />
              </MaterialComposer>
            </ProtectedLayout>
          ),
        },
      ],
    },
    {
      path: "reports",
      children: [
        {
          path: "list",
          element: (
            <ProtectedLayout>
              <MaterialComposer>
                <Reports />
              </MaterialComposer>
            </ProtectedLayout>
          ),
        },
      ],
    },
  ],
};

export default MaterialRoutes;
